import { render } from "./CoachingBriefView.vue?vue&type=template&id=4adad427&scoped=true"
import script from "./CoachingBriefView.vue?vue&type=script&lang=js"
export * from "./CoachingBriefView.vue?vue&type=script&lang=js"

import "./CoachingBriefView.vue?vue&type=style&index=0&id=4adad427&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adad427"]])

export default __exports__